import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { BreadCrumbProvider } from "features/Contexts/BreadCrumbs";
import { CompanyLogoProvider } from "features/Contexts/CompanyLogoContext";
import { CustomerProvider } from "features/Contexts/CustomerContext";
import { WorkOrderProvider } from "features/Contexts/WorkOrderContext";
import NavBar from "../components/NavBar";
import Toast from "components/Toast/ToastComponent";
import { InboxProvider } from "pages/Sales/Inbox/InboxTab/InboxContext";
import { useEffect } from "react";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userInfo) navigate("/");
  }, [navigate, userInfo]);

  // useEffect(() => {
  //   console.log(pathname);
  // }, [pathname]);

  // show unauthorized screen if no user is found in redux store
  return (
    <div className="wrapper">
      <CompanyLogoProvider>
        <WorkOrderProvider>
          <CustomerProvider>
            <InboxProvider>
              <BreadCrumbProvider>
                {/* <TopBar /> */}
                <Toast />
                {"/email/inbox" !== pathname && <NavBar />}
                <div
                  className=""
                  style={{ minHeight: "100vh", backgroundColor: "#f0f4f9" }}
                >
                  <div className="content">
                    <div className="">
                      <Outlet />
                    </div>
                  </div>
                </div>{" "}
              </BreadCrumbProvider>
            </InboxProvider>
          </CustomerProvider>
        </WorkOrderProvider>
      </CompanyLogoProvider>
    </div>
  );
};

export default ProtectedRoute;
